<template>
  <div class="dashboard-container">
    <!-- <v-header title="候选人清单"></v-header> -->
    <el-container class="container">
      <el-main>
        <!-- 时间 & 阶段 选择 -->
        <div class="filter-bar">
          <div class="btns">
            <el-button
              @click="getSumType(item)"
              :type="queryParams.sumType == item.code ? 'primary' : 'default'"
              size="small"
              v-for="(item, key) in btnList"
              :key="key"
              >{{ item.desc }}</el-button
            >
          </div>
          <div>
            <el-select
              size="small"
              v-model="queryParams.timeType"
              @change="getTimeType"
            >
              <el-option
                v-for="item in dataList"
                :key="item.code"
                :label="item.desc"
                :value="item.code"
              />
            </el-select>
            <el-date-picker
              v-if="queryParams.timeType == '3'"
              v-model="queryParams.dateRange"
              size="small"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="to"
              start-placeholder="开始"
              end-placeholder="截至"
              @change="getTime"
            />
          </div>
        </div>

        <!-- 统计数据卡片 -->
        <div class="stats">
          <div class="stat-item">
            <div class="stat-label">简历人数</div>
            <div>
              <i class="el-icon-s-data active"></i>
              <span class="stat-number">{{ board.resumeNum }} 人</span>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-label">面试合格人数</div>
            <div>
              <i class="el-icon-s-flag active"></i>
              <span class="stat-number">{{ board.interviewPassNum }} 人</span>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-label">入司人数</div>
            <div>
              <i class="el-icon-s-marketing active"></i>
              <span class="stat-number">{{ board.entryNum }} 人</span>
            </div>
          </div>
        </div>

        <!-- ECharts 图表 -->
        <div id="chart" class="chart"></div>

        <!-- 机构统计数据 -->
        <div class="summary">
          <div class="summary-block">
            <h3>简历人数机构汇总</h3>
            <ul>
              <li v-for="(num, city) in board.resumeNumSum" :key="city">
                {{ city }}: {{ num }}
              </li>
            </ul>
          </div>
          <div class="summary-block">
            <h3>面试合格机构汇总</h3>
            <ul>
              <li v-for="(num, city) in board.interviewPassNumSum" :key="city">
                {{ city }}: {{ num }}
              </li>
            </ul>
          </div>
          <div class="summary-block">
            <h3>入司人数机构汇总</h3>
            <ul>
              <li v-for="(num, city) in board.entryNumSum" :key="city">
                {{ city }}: {{ num }}
              </li>
            </ul>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>

import * as echarts from "echarts";

// import vHeader from "@/layout/Header1.vue";
import url from "@/modules/url";
import api from "@/modules/api";
export default {
  name: '',
  // components: { vHeader },
  data() {
    return {
      dateRange: [],
      board: {
        resumeNum: '261',
        interviewPassNum: '109',
        entryNum: '57',
        xAxis :["1月1日", "1月2日", "1月3日", "1月4日", "1月5日"],
        resumeSeriesData: [100, 150, 200, 100, 120],
        interviewPassSeriesData: [80, 140, 180, 90, 110],
        entrySeriesData: [50, 100, 150, 70, 90],
        resumeNumSum: {
          北京: 23,
          天津: 34,
          青岛: 32,
          山东: 13,
          江苏: 44,
          辽宁: 45,
          河南: 45,
        },
        interviewPassNumSum: {
          北京: 23,
          天津: 34,
          青岛: 32,
          山东: 13,
          江苏: 44,
          辽宁: 45,
          河南: 45,
        },
        entryNumSum: {
          北京: 23,
          天津: 34,
          青岛: 32,
          山东: 13,
          江苏: 44,
          辽宁: 45,
          河南: 45,
        },
      },
      queryParams: {
        sumType: 1,
        timeType: 1,
        startTime: "",
        endTime: "",
      },
      btnList: [
        { desc: "时间", code: 1 },
        { desc: "阶段", code: 2 },
      ],
      dataList: [
        { desc: "本周", code: 1 },
        { desc: "本月", code: 2 },
        { desc: "时间段", code: 3 },
      ],
    };
  },
  mounted() {
    this.getSumAccount(this.queryParams, this.initChart);
  },
  methods: {
    initChart() {
      const { xAxis,resumeSeriesData, interviewPassSeriesData, entrySeriesData } = this.board
      let chart = echarts.init(document.getElementById("chart"));
      console.log(xAxis, "---------->xAxis")
      let option = {
        tooltip: { trigger: "axis" },
        legend: { data: ["简历人数", "面试合格", "入司人数"] },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: { type: "value" },
        series: [
          {
            name: "简历人数",
            type: "line",
            data: resumeSeriesData,
            smooth: true,
          },
          {
            name: "面试合格",
            type: "line",
            data: interviewPassSeriesData,
            smooth: true,
          },
          {
            name: "入司人数",
            type: "line",
            data: entrySeriesData,
            smooth: true,
          },
        ],
      };

      chart.setOption(option);
    },
    getTimeType(type) {
      if (type != "3") {
        this.getSumAccount(this.queryParams, this.initChart);
      } else {
        
      }
    },
    getSumType(item) {
      this.queryParams.sumType = item.code;
      this.getSumAccount(this.queryParams, this.initChart);
      console.log(item, "=====");
    },
    getTime(val) {
      this.queryParams.startTime = val[0];
      this.queryParams.endTime = val[1];
      this.getSumAccount(this.queryParams, this.initChart);
      console.log(this.queryParams, "this.queryParams", val);
    },
    getSumAccount(data, callback) {
      api.post(url.sumAccount, data, (res) => {
        if (res.result.isSuccess) {
          console.log(res.data, "sumAccountByTime=======");
          this.board = res.data;
          if (callback) {
            callback();
          }
        } else {
          if (res.result.errors.length > 0) {
            this.$message({
              type: "error",
              message: res.result.errors[0].error,
            });
          } else {
            this.$message({
              type: "error",
              message: res.result.error,
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-container {
  /deep/ .container {
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    padding-bottom: 15px;
    background: #ffffff;
  }
}
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .btns {
    display: flex;

    .btn-item {
      width: 50px;
    }
  }
}
.stats {
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-bottom: 20px;
}
.stat-item {
  flex: 1;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 8px;
}
.stat-number {
  font-size: 24px;
  font-weight: bold;
}
.stat-label {
  font-size: 14px;
  color: gray;
}
.active {
  color: #409eff;
}
.chart {
  height: 350px;
}
.summary {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
.summary-block {
  text-align: center;
}
ul {
  list-style: none;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/dataBoard.vue